import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import logo from "../../../svg/OneLogin-logo-symbol_only.svg";
import { svgList } from "@onelogin/react-components";

const ErrorWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #1a1919;
`;

const Image = styled.img`
  display: block;
  padding: 35px;
  max-width: 250px;
  width: 100%;
`;

const ErrorHeader = styled.div`
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const ErrorMessage = styled.div`
  font-size: 18px;
  margin: 40px;
`;

const ErrorHelp = styled.div`
  font-size: 18px;
  line-height: 1.67;
  margin: 0 40px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const AccessDenied = ({ message }) => {
  return (
    <ErrorWrapper>
      <Image src={logo} alt="OneLogin logo" />
      <ErrorHeader>
        <img alt="Alert" src={svgList.Alert} height={40} width={40} />
        <FormattedMessage defaultMessage="Access Denied" id="accessDenied" />
      </ErrorHeader>
      <ErrorMessage>{message}</ErrorMessage>
      <ErrorHelp>
        <a href="/portal">
          <FormattedMessage
            defaultMessage="Go Back to Portal"
            id="goBackToPortal"
          />
        </a>

        <a href="/portal/help">
          <FormattedMessage
            defaultMessage="Contact Help Desk"
            id="contactHelpDesk"
          />
        </a>
      </ErrorHelp>
    </ErrorWrapper >
  );
};

AccessDenied.propTypes = {
  message: PropTypes.string.isRequired
};

export default AccessDenied;
